// extracted by mini-css-extract-plugin
module.exports = {"timer-root":"style_timer-root__7dgUe"};